var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      staticStyle: { padding: "40px 0 40px 0", "background-color": "#ffffff" }
    },
    [
      _c(
        "el-col",
        {
          staticStyle: { display: "flex", "justify-content": "center" },
          attrs: { span: 24 }
        },
        [
          _c(
            "a",
            {
              staticStyle: { display: "flex", "justify-content": "center" },
              attrs: {
                id: "homePageCreativeAdsPolePosition",
                href: _vm.propsClick,
                target: "_blank"
              }
            },
            [
              _c("img", {
                staticClass: "image-ad",
                attrs: { src: _vm.propsImage, loading: "lazy" }
              })
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f866984c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f866984c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/package/advertisementOne.vue
// module id = null
// module chunks = 